export const FIFTEEN_SECONDS_IN_MILLISECONDS = 15000
